import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useRecoilValue } from 'recoil';

import { API_QUERY_KEYS, getStatisticsReport, QueryDefaults } from 'api';
import { statisticsRequestState } from 'store';
import { StatisticsReport } from 'types';

export const useStatisticsReport = (): UseQueryResult<StatisticsReport> => {
  const request = useRecoilValue(statisticsRequestState);
  return useQuery(
    [API_QUERY_KEYS.getStatisticsReport, request],
    () => getStatisticsReport(request),
    QueryDefaults
  );
};
